import dayjs from "dayjs"
import it from "dayjs/locale/it"
import customParseFormat from "dayjs/plugin/customParseFormat"
import moment from "moment"
import React from "react"
import ReactDOM from "react-dom"

import App from "./App"
import reportWebVitals from "./reportWebVitals"

dayjs.extend(customParseFormat)
dayjs.locale(it)
moment.locale("it-IT")

// ----------------------------------------------------------------------------

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById("root")
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
